import React, { useEffect, useState } from 'react';

import { AuthApiError, User } from '@ergeon/erg-auth';

import { authService } from '../../auth/service';

import { AuthContext } from './AuthContext';

const AuthContextProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [user, setUser] = useState<User>();
  const [error, setError] = useState<AuthApiError>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const authenticate = () => {
    setIsLoading(true);
    authService.authenticate();
  };

  const logout = () => {
    setIsLoading(true);
    authService.logout(undefined, false, (authError) => {
      setError(authError);
      setIsLoading(false);
      if (!authError) {
        setUser(undefined);
      }
    });
  };

  const getUser = () => {
    setIsLoading(true);

    authService.getUser((authError, authData) => {
      setError(authError);
      setUser(authData);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    authService.on('refresh', getUser);
    getUser();

    return () => authService.off('refresh', getUser);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        authenticate,
        logout,
        error,
        user,
        isLoading,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
